import { g as r } from "./global.js";
import { f as t } from "./fails.js";
import { f as s } from "./function-uncurry-this.js";
import { t as o } from "./to-string.js";
import { s as i } from "./string-trim.js";
import { w as m } from "./whitespaces.js";
var a = i.trim,
  n = r.parseInt,
  f = r.Symbol,
  e = f && f.iterator,
  p = /^[+-]?0x/i,
  c = s(p.exec),
  j = 8 !== n(m + "08") || 22 !== n(m + "0x16") || e && !t(function () {
    n(Object(e));
  }) ? function (r, t) {
    var s = a(o(r));
    return n(s, t >>> 0 || (c(p, s) ? 16 : 10));
  } : n;
export { j as n };